import packageJson from 'package.json';
import { ChangeDetectorRef, Component, ComponentRef, ElementRef, HostBinding, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { WIZ_PHYSIC_POSITION, WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import {
  WizPopUp,
  WizRoot,
  WizComponentManager,
  WizLabel,
  WizImage,
  WizSpacer,
  WizEventManager,
  WizTranslationManager,
  COMPONENTRESOURCES,
  WizEvent,
  WizNavigationManager,
  WizActionObj
} from '@wizeoo/akm-component-lib';
import { ALK_EVENT_TYPE, StyleEngine, ViewData, VISION_PROPERTY } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { BusinessUnitVO } from '@wizeoo/akm-common-lib';
import { TranslationPop } from '@wizeoo/akm-common-lib';
import { Observable } from 'rxjs';
import { WizNumericInput } from '@wizeoo/akm-component-lib';
import { VisionVO } from '@wizeoo/akm-compute-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { TabVO } from '@wizeoo/akm-common-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { UserTabView } from '../../user-tab/user-tab.view';
import { ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'information-bar',
  templateUrl: './information.bar.html'
})
export class InformationBar implements OnInit {
  
  /** gestion dynamique de la couleur des barres */
  @HostBinding('style.background') get background() {
    if(Model.getInstance().currentVision?.color) {
      return Model.getInstance().currentVision?.color;
    } else {
      return StyleEngine.STYLE_DEFAULT_BAR_COLOR;
    }
  }

  // container HTML pour chargement des fonctions permanentes
  @ViewChild('breadContainer', { read: ViewContainerRef, static: true }) breadContainer: ViewContainerRef;
  @ViewChild('computeLevel', { read: WizNumericInput, static: true }) computeLevel: WizNumericInput; // niveau à calculer
  @ViewChild('imgRunMode', { read: WizImage, static: true }) imgRunMode: WizImage; // rendu du mode

  constructor(private route: ActivatedRoute, public elementRef: ElementRef, private cdref: ChangeDetectorRef) {
  }


  /** icones des modes de lancement */
  public get modeIcon(): any {
    return Model.getInstance().visionEngine.getVisionProperties(Model.getInstance().currentVision, VISION_PROPERTY.RUN_MODE_ICON);
  }

  /** tooltips des modes de lancement */
  public get modeTooltip(): string {
    let mode: string = Model.getInstance().visionEngine.getVisionProperties(Model.getInstance().currentVision, VISION_PROPERTY.RUN_MODE_TOOLTIP) || '';
    if(mode) {
      mode = WizTranslationManager.getInstance().translateKey(mode);
    }
    return mode;
  }

  /** l'instance de PopUp des langues */
  private translationPop: WizPopUp;

  // private dommainPart: string; // le libellé du domain
  private buPart: string; // le libellé de la BU
  private visionPart: string; // le libellé de la vision

  // private dommainIcon: any; // la source de l'icone du domain
  private buIcon: Observable<string>; // la source de l'icone de bu
  private visionIcon: Observable<string>; // la source de l'icone de vision

  private supportMail: string = null; // mail du support
  public supportVisible: boolean = false; // accès au mail du support, si porté par la BU ou la vision

  private defaultHelpUrl: string = 'https://www.allkey.me'; // url de l'aide en ligne
  private helpUrl: string = 'https://www.allkey.me'; // l'aide en ligne actuelle

  /**
   * Retourne la version de l'application depuis le package.json
   */
  get applicationVersion(): string {
    return packageJson.version;
  }

  ngOnInit() {
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.SELECT_VISION, this.updateVision);
    // fin chargement des trads, refresh des libellés
    WizEventManager.addListener(this, WizRoot.root(), WIZ_EVENT_TYPE.TRANSLATION_LOADED, this.updateVision);
    // modification d'une vision, peut-être celle en cours
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.ALTER_VISION, this.updateVision);

    // écouteur sur la naviagtion
    WizEventManager.addListener(this, WizRoot.root(), WIZ_EVENT_TYPE.NAVIGATE_END, this.afterNavigation);

    // le domaine et la BU du user sont déjà dispo
    this.updateVision(null);
    this.afterNavigation(null);
  }


  /** écouteur sur changement de vision */
  private updateVision(e: any = null): void {
    const bu: BusinessUnitVO = Model.getInstance().businessUnitEngine.currentBU;
    if (bu) {
      this.buPart = bu.name + ' (' + bu.domain + ')';
      this.buIcon = bu.iconOrDie;
    } else {
      this.buPart = null;
      this.buIcon = null;
    }

    const vision: VisionVO = Model.getInstance().currentVision;
    if (vision) {
      this.visionIcon = Model.getInstance().visionEngine.getVisionIconOrDie(vision);
      this.visionPart = Model.getInstance().visionEngine.getVisionLabel(vision);
    } else {
      this.visionPart = null;
      this.visionIcon = null;
    }




    this.updateBreadCrumb(); // on dessine les compos (au pire, rien)
  }

  // application des textes depuis la vue source
  private updateBreadCrumb(): void {
    this.breadContainer.clear();

    let meCompo: ComponentRef<any>;

    // ajout de la BU
    meCompo = WizComponentManager.instance.addChildTo(WizImage, this.breadContainer, {
      instanceProperties: { sourceObservable: this.buIcon },
      cssClasses: ['roundedImage'],
      styleProperties: { height: '25px', width: '25px'},
    });
    meCompo = WizComponentManager.instance.addChildTo(WizSpacer, this.breadContainer, {
      styleProperties: { width: '5px' },
    });
    meCompo = WizComponentManager.instance.addChildTo(WizLabel, this.breadContainer, {
      instanceProperties: {
        wizLabel: this.buPart,
      },
    });

    meCompo = WizComponentManager.instance.addChildTo(WizSpacer, this.breadContainer, {
      styleProperties: { width: '10px' },
    });

    if (this.visionPart) {
      // ajout de la vision
      meCompo = WizComponentManager.instance.addChildTo(WizImage, this.breadContainer, {
        instanceProperties: { sourceObservable: this.visionIcon },
        cssClasses: ['roundedImage'],
        styleProperties: { height: '25px', width: '25px'},
      });
      meCompo = WizComponentManager.instance.addChildTo(WizSpacer, this.breadContainer, {
        styleProperties: { width: '5px' },
      });
      meCompo = WizComponentManager.instance.addChildTo(WizLabel, this.breadContainer, {
        instanceProperties: {
          wizLabel: this.visionPart,
        },
      });
    }

    // mise à jour du contact support et de l'url date
    const bu: BusinessUnitVO = Model.getInstance().businessUnitEngine.currentBU;
    const visionCode: VisionVO = Model.getInstance().currentVision;
    let hasSupport: boolean = false;
    if(!!visionCode?.supportMail) {
      hasSupport = true;
      this.supportMail = visionCode.supportMail;
    } else if(!!bu?.supportMail ) {
      hasSupport = true;
      this.supportMail = bu.supportMail;
    }else {
      this.supportMail = null;
    }

    this.supportVisible = hasSupport;

    if(!!visionCode?.helpURL) {
      this.helpUrl = visionCode.helpURL;
    } else if(!!bu?.helpURL) {
      this.helpUrl = bu.helpURL;
    } else {
      this.helpUrl = this.defaultHelpUrl;
    }

  }

  // ####
  // ####
  // #### boutons de fonction à droite
  // ####
  // ####

  // accès à l'aide
  public getInfo(): void {
    window.open(this.helpUrl, "_blank");
  }

  /** ouverture de la popUp de choix des langues */
  public getLanguage(): void {
    this.translationPop = new WizPopUp( 
      TranslationPop,
      false,
      false,
      WIZ_PHYSIC_POSITION.BOTTOM_RIGHT,
      null,
      null, // calc(100% - 81px)',
      Model.getInstance()
    ).show();
  }


  // accès au support
  public getSupport(): void {
    // console.log('support button clicked');   
    const mail: string = this.supportMail;
    const domain: string = "Domain: " + Model.getInstance().domainCode;
    const bu: string = "Business Unit: " + Model.getInstance().businessUnitCode;
    const vision: string ="Vision: " +  Model.getInstance().visionCode;
    const subject: string = WizTranslationManager.getInstance().translateKey('$.common.support.subject.$', null, 'Ask for support');
    const body: string = [domain, bu, vision].join('%0D%0A');

    const target = ["mailto:", mail, "?subject=", subject, "&body=", body].join('');
    window.location.href = target;
  }

  public usePdfExport(): boolean {
    return !!Model.getInstance().currentVision?.usePdfExport;
  }

  public PDF: any = COMPONENTRESOURCES.PDF;

  /**
   * bouton d'export des données
   */
  public exportDatas(): void {
    // contrôle de la cohérence des widgets asservis
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.PDF_PRINT_REQUEST, null));
  }


  public currentTab: TabVO = null; // onglet de vue cible
  public color: string = "black";
  public viewIcon: string = null;
  public viewMaterial: string = null;
  public viewImage: Observable<string> = null;
  public viewLabel: string = null;
  public tooltipText: string = null;
  

  private resolveTab(params: ParamMap): void {
    const tabCode: string = params.get('code');
    this.currentTab = Model.getInstance().tabEngine.getTabByCode(Model.getInstance().visionCode + ViewData.KEY_SEPARATOR + tabCode);

    console.log('resolveTab', tabCode, this.currentTab);
  }





  /**
   * prise du tab en cours pour affichage de l'icone et du label
   * @param e 
   */
  public afterNavigation(e: WizEvent = null): void {
    setTimeout(() => {
      const currV: BaseView = Model.getInstance().navigationEngine.getCurrentView();
      let pTabCode: string = currV.code;

      if(currV instanceof UserTabView) {    
        pTabCode = (currV as UserTabView).route.snapshot.paramMap.get('code');
      }

      // console.log("pTabCode", pTabCode);
      let ds = Model.getInstance().tabEngine.currentTabs;
      const action: WizActionObj = ds.find((v) => v.featureCode === pTabCode || v.buttonCode === pTabCode);
      // let precursors: WizActionObj[] = Model.getInstance().tabEngine.currentTabs;
      
      // // let me: TabVO = Model.getInstance().tabEngine.getTabByCode([...Model.getInstance().currentViews.keys()][0]);
      // console.log("precursors",ds, action);
      
      this.viewIcon = null;
      this.viewImage = null;
      this.viewMaterial = null;
      this.viewLabel = " ";
      this.tooltipText = null;
      this.color = 'black';

      if(!!action) {
        this.viewLabel = action?.label;
        this.tooltipText = action.description || action.label;
        this.color = action.lineColor || 'black';

        try {
          if(!!action.imageSource) {
            let parts: string[] = action.imageSource.split('|');
            if(parts.length === 1) {
              this.viewIcon = action.imageSource;
            } else {
              switch(parts[0]) {
                case 'mat':
                  this.viewMaterial = parts[1];
                break;
                case 'img': 
                  this.viewImage = action.imgObs;
                break;
              }
            }
          }
        } catch(e:any) {
          // console.log('btn img', action.buttonCode, action.imageSource);
        }
      }

    }, 0);

  }

}
